export default "__VITE_ASSET__CnJ1h8WC__"